import { UuidBaseFilterLookup } from 'gql-types';
import moment, { Moment } from 'moment';

export const ONE_DAY_MS = 24 * 60 * 60 * 1000;

// Overloads allow typescript to recognize when the output is actually nullable.
function date(date: Moment | Date | string): string;
function date(date: null): null;
function date(date: Moment | Date | string | null): string | null;
function date(date: Moment | Date | string | null): string | null {
    if (date === null) {
        return null;
    }
    if (typeof date === 'string') {
        // Verify string is in YYYY-MM-DD format
        const datePattern = /^\d{4}-\d{2}-\d{2}$/;
        if (!datePattern.test(date)) {
            throw new Error('Date string must be in YYYY-MM-DD format');
        }
        return date;
    }
    const dateMoment = date instanceof Date ? moment(date) : date;
    return dateMoment.format('YYYY-MM-DD');
}

// Overloads allow typescript to recognize when the output is actually nullable.
function datetime(datetime: Moment | Date): string;
function datetime(datetime: null): null;
function datetime(datetime: Moment | Date | null): string | null;
function datetime(datetime: Moment | Date | null): string | null {
    if (datetime === null) {
        return null;
    }
    const datetimeMoment = datetime instanceof Date ? moment(datetime) : datetime;
    return datetimeMoment.toISOString();
}

type IdInListOrNoneFilter = {
    id: UuidBaseFilterLookup;
    OR?: { id: UuidBaseFilterLookup };
};

/**
 * Filter for a relation by the selected ids, where `noneId` in the selection also matches
 * objects with no related object. The OR stays inside the relation filter, so it can't
 * combine with the caller's sibling filters.
 */
function idInListOrNone(selectedIds: string[], noneId: string): IdInListOrNoneFilter | undefined {
    const ids = selectedIds.filter((id) => id !== noneId);
    const includeNone = ids.length !== selectedIds.length;
    if (!includeNone) {
        return ids.length ? { id: { inList: ids } } : undefined;
    }
    if (!ids.length) {
        return { id: { isNull: true } };
    }
    return { id: { inList: ids }, OR: { id: { isNull: true } } };
}

export const GraphInputHelpers = {
    date,
    datetime,
    idInListOrNone,
};
